import React from 'react';
import { DiffValue } from './DiffValue';

export const ScaffoldingDiffValue = ({ value, diff }) => (
    <DiffValue value={value} diff={diff} />
);
